module.exports = __webpack_public_path__ + "static/media/banner-web.da94c96b.jpg";